import { useEffect, useState } from "react";
import { http } from "../lib/api";

export function AgentInstructionAcks({ agentId }) {
  const [items, setItems] = useState([]);
  useEffect(() => { http.get(`/agents/${agentId}/instruction-acks`).then((r) => setItems(r.data)).catch(() => {}); }, [agentId]);
  if (!items.length) return null;
  return (
    <div className="border border-slate-200 rounded-md p-4" data-testid="agent-instruction-acks">
      <div className="font-display font-bold mb-2">Consignes lues et confirmées</div>
      <div className="divide-y divide-slate-100 text-sm">
        {items.map((a) => (
          <div key={a.id} className="py-1.5 flex justify-between gap-3">
            <span>{a.title} <span className="text-xs text-slate-500">· {a.site_name} · v{a.version}</span></span>
            <span className="text-xs text-slate-500 whitespace-nowrap">{new Date(a.at).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" })}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
